import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import * as productDocumentTypes from './productDocumentTypes';

const byId = handleActions(
  {
    [productDocumentTypes.PRODUCT_DOCUMENT_LIST_FOR_PRODUCT.SUCCESS]: (state, { payload }) => ({
      ...state,
      ...payload.entities.productDocuments,
    }),
  },
  {},
);

const allIds = handleActions(
  {
    [productDocumentTypes.PRODUCT_DOCUMENT_LIST_FOR_PRODUCT.SUCCESS]: (state, { payload }) => [
      ...new Set([...state, ...payload.result]),
    ],
  },
  [],
);

export default combineReducers({
  byId,
  list: combineReducers({
    allIds,
  }),
});
